// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import { useEffect, useRef, useState } from "react"

export default function Toast() {
  const [msg, setMsg] = useState("")
  const [show, setShow] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    function onToast(e: Event) {
      setMsg((e as CustomEvent<{ msg: string }>).detail.msg)
      setShow(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setShow(false), 2200)
    }
    window.addEventListener("fithub:toast", onToast)
    return () => {
      window.removeEventListener("fithub:toast", onToast)
      clearTimeout(timer.current)
    }
  }, [])

  return <div className={"toast" + (show ? " show" : "")} role="status" aria-live="polite">{msg}</div>
}
